import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.dettachCompany.alertTitle, 'Alert'),
  cancel: () => __(translations.dettachCompany.cancel, 'Cancel'),
  yesImSure: () => __(translations.dettachCompany.yesImSure, "Yes, I'm sure"),
  dettachAlertMessage: () => __(translations.dettachCompany.dettachAlertMessage, 'Are you sure you want to dettach this contact?'),
};
